import { createAction, props } from '@ngrx/store';

export const LOADS_SOURCING = {
	LOADS_LIST: {
		PAGE: createAction('[Loads Sourcing] Set loads sourcing page', props<any>()),
		PAGE_SIZE: createAction('[Loads Sourcing] Set loads sourcing page size', props<any>()),
		GET: createAction('[Loads Sourcing] Get loads sourcing list', props<any>()),
		SUCCESS: createAction('[Loads Sourcing] Get loads sourcing list success', props<any>()),
		FAILURE: createAction(
			'[Loads Sourcing] Get loads sourcing list failure',
			props<{ payload: { message: string } }>()
		),
	},
	CARRIER: {
		CARRIER_ID_SUCCESS: createAction('[Loads Sourcing] set carrier id', props<any>()),
		GET: createAction('[Loads Sourcing] Get carrier info', props<any>()),
		SUCCESS: createAction('[Loads Sourcing] Get carrier info success', props<any>()),
		FAILURE: createAction(
			'[Loads Sourcing] Get carrier info failure',
			props<{ payload: { message: string } }>()
		),
	},
	ACCOUNT: {
		ID_SUCCESS: createAction('[Loads Sourcing] set account id', props<any>()),
		LOGO_SUCCESS: createAction('[Loads Sourcing] set account logo', props<any>()),
		BUSINESS_NAME: createAction('[Loads Sourcing] set account business name', props<any>()),
	},
	OFFER: {
		ALL_BIDS_SUBMITTED: createAction('[Loads Sourcing] finished submitting all bids', props<any>()),
		OPEN_DIALOG: createAction('[Loads Sourcing] open make offers dialog', props<any>()),
		DIALOG_SUCCESS: createAction('[Loads Sourcing] successfully made offers', props<any>()),
		DIALOG_LOAD_SUCCESS: createAction(
			'[Loads Sourcing] successfully made offer for load',
			props<any>()
		),
		DIALOG_LOAD_FAILURE: createAction(
			'[Loads Sourcing] unsuccessfully made offer for load',
			props<any>()
		),
		DIALOG_RATE_CHANGE: createAction('[Loads Sourcing] dialog rate changed', props<any>()),
		CLOSE_DIALOG: createAction('[Loads Sourcing] close make offers dialog', props<any>()),
		FAILED: createAction('[Loads Sourcing] make offers failed', props<any>()),
	},
	INSTRUCTIONS: {
		DIALOG: createAction('[Loads Sourcing] get settings for instructions dialog', props<any>()),
		DIALOG_OPEN: createAction('[Loads Sourcing] open instructions dialog', props<any>()),
		DIALOG_CLOSE: createAction('[Loads Sourcing] close instructions dialog', props<any>()),
	},
};
